import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import {
    type IBuyerRegistrationProfileInfoClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/IBuyerRegistrationProfileInfoClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class SupporterBuyerRegistrationProfileInfoQuery {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('IBuyerRegistrationProfileInfoClient')
        public readonly buyerRegistrationProfileInfoClient: IBuyerRegistrationProfileInfoClient,
    ) {}

    public async fetch(): Promise<IGetResponse['data']> {
        const { data, message } = await this.buyerRegistrationProfileInfoClient.get({
            supporterToken: this.supportUserToken.get() || undefined,
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}
